<template>
  <div class="container">
    <div class="top-header">
      <!-- 医疗器械大数据中心 -->
      <div class="nav-left">
        <!-- <p class="logo" id="logoShow" ref="logoShow">AccuTarget</p> -->
        <!-- <div class="logo">
          <img src="../../assets/image/logo.png"/>
        </div> -->
        <!-- <img src="../../assets/image/logo.png" class="logo" /> -->
        <img src="../../assets/image/logo-color.png" class="logo" />
      </div>
      <p class="nav-center">导向医疗产品数据中心</p>
      <div class="nav-right">
          <p class="fix">{{currentDate}}</p>
      </div>
    </div>
    <div class="content">
      <div class="content-right">
        <!-- 1.全国触点 -->
        <div class="part-left-one">
          <p class="part-title">全国触点</p>
          <div class="part-content"  style="height:260px">
            <div class="part-content-detail">
              <p>已覆盖地区</p>
              <div v-for="(item,index) in provinceArray">
                <span>{{item}}</span>
              </div>
            </div>
            <div class="part-content-detail" style="margin-top: 50px;">
              <p>已覆盖触点</p>
              <div v-for="(item,index) in hospitalArray">
                <span>{{item}}</span>
              </div>
            </div>
          </div>
        </div>
        <div style="border-style: dashed;border-width: 1px;border-color: darkgray;border-spacing: 3px;margin: 30px 0 ;"></div>
        <!-- 2.地区触点 -->
        <div class="part-left-one">
          <p class="part-title">地区触点</p>
            <div class="part-content-two" id="partTwoOfEquip" ref="partTwoOfEquip">
              <div style="width: 100%;height: 100%;"  ref="cityChart" id="cityChart"></div>
            </div>
        </div>

      </div>

      <div class="content-center">
        <div class="content-map" id="mapContent">
          <dv-border-box-10>
            <div id="mapBox" class="map-back">
                <div class="echart-map" ref="chinaEchart">
                </div>
            </div>
          </dv-border-box-10>
        </div>
      </div>

      <div class="content-right">
        <div class="data-analysis">
          <div class="cons-sales">
            <p class="part-title">累计耗材数</p>
            <div class="cons-sales-chart" id="consYearSalesChart" ref="consYearSalesChart"></div>
          </div>
        </div>
        <div style="border-style: dashed;border-width: 1px;border-color: darkgray;border-spacing: 3px;margin: 30px 0 ;"></div>
        <div class="part-left-one">
          <p class="part-title">耗材消耗</p>

          <div class="part-content-two" id="partTwoOfCons" ref="partTwoOfCons">

            <div class="part-content-sales">
              <p>耗材总数</p>
              <p><span>{{consSalesData.total}}</span>支</p>
            </div>
            <div class="part-content-sales" >
              <p>当年耗材数</p>
              <p><span>{{consSalesData.year}}</span>支</p>
            </div>
            <div class="part-content-sales" >
              <p>当月耗材数</p>
              <p><span>{{consSalesData.month}}</span>支</p>
            </div>
            <div class="part-content-sales" >
              <p>今日耗材数</p>
              <p><span>{{consSalesData.today}}</span>支</p>
            </div>
          </div>

        </div>

      </div>

    </div>

  </div>

</template>

<script>
// import * as echarts from 'echarts';
import { forEach, split } from 'lodash';
import {areaConversionUtil} from '../../utils/povince_handle.js'

  export default {
    data() {
      return {
        currentDate:'',

        //全国触点
        provinceArray:[],//已覆盖地区
        hospitalArray:[],//已覆盖触点

        // 地区触点
        hospitalDisArray:[],

        geoJson:{},
        // 设备状态的统计
        consSalesData:{
          total:0,
          year:0,
          month:0,
          today:0
        },

        // 耗材月销量
        consMonthData:{
          year:[],
          month:[],
          value:[]
        },

        //耗材年销量
        consYearData:{
          year:[],
          month:[],
          value:[]
        },

        mapDistributionData:[],//地图上各省份设备统计

        loading:false,
        value4:new Date(),
        value5:new Date(),
        weeks:['周日','周一','周二','周三','周四','周五','周六'],


        // myChart11:null,//全国触点
        myChart12:null,//地区触点
        myMapChart:null,//地图
        myChart31:null,//累计耗材数

        timerId:null,
        // timerIdId:null,
      }
    },
    beforeDestroy() {

      clearTimeout(this.timerId)
      this.timerId = null;
      // clearTimeout(this.timerIdId)
      // this.timerIdId = null;

      window.removeEventListener('resize',this.mapBoxResize)
      window.removeEventListener('resize',this.sizeOfmyMapChart)
      window.removeEventListener('resize',this.sizeFunOfMyChart12)
      window.removeEventListener('resize',this.sizeFunOfMyChart31)

      if(this.myChart12){
        this.myChart12.dispose();
        this.myChart12 = null;
      }
      if(this.myChart31){
        this.myChart31.dispose();
        this.myChart31 = null;
      }

      if(this.myMapChart){
        this.myMapChart.dispose();
        this.myMapChart = null;
      }
    },
    created() {

      this.getCurrentDate();

    },
    mounted() {

      window.addEventListener('resize',this.mapBoxResize)

      this.mapBoxResize();

      // 布局
      this.setMap()
      this.setCityChart()//地区触点
      this.setConsYearChart()

      // 获取数据
      this.getConsYearDistribution()
      this.getDistribution();//各省设备医院分布
      this.getEquipDis()
      this.getConsSalesDistribution();


      sessionStorage.removeItem('loaded');

      //页面加载完之后调用
      this.scheduleRefresh();
    },
    methods:{
      tableCellStyle() {
        return 'border-color: transparent;color: #fff;text-align:center;'
      },
      tableHeaderCellStyle() {
        return 'border-color: transparent;color:lightgray;text-align:center;background-color:transparent;'
      },
      // 定时刷新
       scheduleRefresh() {
            // const now = new Date();
            // const nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 17, 2, 59); // 获取当天的23:59:59
            // const delay = nextMidnight.getTime() - now.getTime(); // 计算至零点的毫秒数

            // this.timerId = setTimeout(function(){
            //   var timer = setTimeout(function(){
            //     window.location.reload()
            //   },1000);
            // },delay)

            this.timerId = setTimeout(function(){
              window.location.reload()
            },6 * 60 * 60 * 1000);


            // 每次调用后设置下一次定时刷新
            // this.timerIdId = setTimeout(this.scheduleRefresh(), delay + 24 * 60 * 60 * 1000); // 加一天的毫秒数，即次日的零点
      },
      getCurrentDate(){
        var date = new Date()
        var year = date.getFullYear()
        var month =  date.getMonth()+1
        var date = date.getDate()

        var day = new Date().getDay()

        this.currentDate =  this.judgeNumber(year) +'年' + this.judgeNumber(month) + '月' + this.judgeNumber(date) + '日 ' + this.weeks[parseInt(day)]
      },
      judgeNumber(value){
        if(value<10){
          return '0'+value;
        }
        return value;
      },
      handleNumber(value){

        var vvv = '' + value
        var array = vvv.split('')
        return array;
      },

      mapBoxResize(){

        const HH = window.innerHeight;
        //地图
        var element1 = this.$refs.chinaEchart;
        var element2 = this.$refs.partTwoOfEquip;
        var element3 = this.$refs.partTwoOfCons;


        const h1 = HH-140;
        element1.style.height = h1<600? 600+'px' : h1+'px';

        const h2 = HH-550;
        element2.style.height = h2<300? 300+'px':h2+'px';
        element3.style.height = h2<300? 300+'px':h2+'px';
      },
      // setLogo(){
      //   var myLogoEchart = echarts.init(this.$refs.chinaEchart);

      //   var logoOption = {
      //     graphic: {
      //       elements: [
      //         {
      //           type: 'text',
      //           left: 'center',
      //           top: 'center',
      //           style: {
      //             text: 'AccuTarget',
      //             fontSize: 80,
      //             fontWeight: 'bold',
      //             lineDash: [0, 200],
      //             lineDashOffset: 0,
      //             fill: 'transparent',
      //             stroke: '#000',
      //             lineWidth: 1,
      //           },
      //           keyframeAnimation: {
      //             duration: 3000,
      //             loop: true,
      //             keyframes: [
      //               {
      //                 percent: 0.7,
      //                 style: {
      //                   fill: 'transparent',
      //                   // lineDashOffset: 200,
      //                   // lineDash: [200, 0]
      //                   lineDash:[20,0],
      //                   lineDashOffset:20,
      //                 }
      //               },
      //               {
      //                 percent: 0.8,
      //                 style: {
      //                   fill: 'transparent'
      //                 }
      //               },
      //               {
      //                 percent: 1,
      //                 style: {
      //                   fill: 'black'
      //                 }
      //               }
      //             ]
      //           }
      //         }
      //       ]
      //     }
      //   };

      //   logoOption && myLogoEchart.setOption(logoOption);
      // },

      setMap(){
        // var myEchart = echarts.init(this.$refs.chinaEchart);

        var myEchart = this.$refs.chinaEchart;
        this.myMapChart = echarts.getInstanceByDom(myEchart);
        if(this.myMapChart === undefined){
          this.myMapChart = echarts.init(myEchart);
        }else{
          this.myMapChart.dispose()
          this.myMapChart = null;
          this.myMapChart = echarts.init(myEchart);
        }


        const geoData = this.$geo;
        echarts.registerMap("China", geoData);

        // // 数据处理
        // var originalData = this.mapDistributionData;

        // var outdata = [];

        // // 名字处理
        // for (var i = 0; i < originalData.length; i++) {
        //   var element = originalData[i];
        //   var name = element.provinceName
        //   if(name == '新疆维吾尔自治区'){name = '新疆'}
        //   else if(name == '内蒙古自治区'){name = '内蒙古'}
        //   else if(name == '宁夏回族自治区'){name = '宁夏'}
        //   else if(name == '广西壮族自治区'){name = '广西'}
        //   else if(name == '西藏自治区'){name = '西藏'}
        //   else if(name == '澳门特别行政区'){name = '澳门'}
        //   else if(name == '香港特别行政区'){name = '香港'}
        //   else {name = name.substring(0,name.length-1)}
        //   outdata.push({
        //     name:name,
        //     value:element.equipmentAmount
        //   })
        // }
        // this.myMapChart.setOption(option);

        var option = {
          tooltip: {
            show: true,
          },
          visualMap: [
            {
                show: true,
                min: 0,
                max: 1000,
                left: "10%",
                top: "bottom",
                bottom:'-15%',
                showLabel: true,
                type:'piecewise',
                pieces: [
                  {gte: 20,label: ">=20 "},
                  {gte: 10,lt: 20,label: "10-19"},
                  {gte: 1,lt: 10,label: "1-9"},
                  // {gte:0,lte: 0,label: '未覆盖'}
                ],
                inRange:{
                  color:['rgba(0,234,255,0.8)','#00EBF4','rgba(0,108,255,0.7)','#3963bc']//#3963bc,#215495
                },
                show: true,
                textStyle:{
                  color:"#fff",
                },
              },
          ],
          geo: {
            map: "China",
            show:true,
            roam:false,
            label: {
              show: true,
              normal:{
                show:true,
                fontSize:'14',
                color:'rgba(0,0,0,0.7)'
              },
            },
            layoutSize:'100%',
            regions: [
                        {
                          name: "南海诸岛",
                          itemStyle: {
                            // 隐藏地图
                            normal: {
                              opacity: 0, // 为 0 时不绘制该图形
                            },
                          },
                          label: {
                            show: false, // 隐藏文字
                          },
                        },
            ],
            itemStyle: {
              color: "#fff",
              normal:{
                borderColor:'rgba(0,0,0,0.2)',
                // / 地图背景色
                      color: {
                        type: "radial",
                        x: 0.5,
                        y: 0.5,
                        r: 0.5,
                        colorStops: [
                          {
                            offset: 0,
                            color: 'rgba(0,234,255,0.9)'
                          },
                          {
                            offset: 1,
                            color: 'rgba(0,234,255,0.9)',
                          },
                        ],
                        global: false, // 缺省为 false
                      },
                      emphasis:{
                            shadowOffsetX:0,
                            shadowOffsetY:0,
                            borderWidth:0,
                          },
              },
            },
            zlevel:1,
          },
          series: [
            // 这里是地区颜色
            {
              name: "设备分布",
              type: "map",
              geoIndex: 0,
              data: [],//outdata,
            },

            // // 这里是散点图
            // {
            //   type: "scatter",
            //   coordinateSystem: "geo",
            //   itemStyle: {
            //     color: "#f00",
            //   },
            //   data: [
            //     {
            //       value: [106.9, 27.7, 100],
            //       symbolSize: 10,
            //       itemStyle: {
            //         color: "#f00",
            //       },
            //     },
            //     {
            //       value: [117.57, 34.86, 220],
            //       symbolSize: 20,
            //       itemStyle: {
            //         color: "#f0f",
            //       },
            //     },
            //   ],
            // },
          ],
        };

        this.myMapChart.setOption(option);
        window.addEventListener('resize',this.sizeOfmyMapChart);
      },

      sizeOfmyMapChart(){
        if(this.myMapChart){
          this.myMapChart.resize()
        }

      },

      // 地区触点
      setCityChart(){
        var chart12 = this.$refs.cityChart;
        this.myChart12 = echarts.getInstanceByDom(chart12);
        if(this.myChart12 === undefined){
          this.myChart12 = echarts.init(chart12);
        }else{
          this.myChart12.dispose()
          this.myChart12 = null;
          this.myChart12 = echarts.init(chart12);
        }

        var option = {
          grid: {
            left: "5%",
            right: "5%",
            bottom: "5%",
            top: "10%",
            containLabel: true,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "none",
            },
            formatter: function (params) {
              return (
                params[0].name +
                "<br/>" +
                "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:rgba(36,207,233,0.9)'></span>" +
                params[0].seriesName +
                " : " +
                params[0].value +
                " <br/>"
              );
            },
          },
          legend: {
            right:0,
            textStyle: {
              color: "#fff",
            },
            data: ['已实施','未实施'],
          },
          xAxis: {
            show: false,
            type: "value",
            textStyle:{
              color:'#fff',
              textStyle:{
                color:'#fff'
              }
            }
          },
          yAxis: [
            {
              type: "category",
              inverse: true,
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#fff',
                },
              },
              splitLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: false,
              },
              data: [],//xData
            },
            {
              type: "category",
              inverse: true,
              axisTick: "none",
              axisLine: "none",
              show: true,
              axisLabel: {
                show:false,
                textStyle: {
                  color: "#ffffff",
                  fontSize: "12",
                },
                formatter: function (value) {
                  return value.toLocaleString();
                },
              },
              data: [],//yData
            },
          ],
          series: [
            {
              name: "已实施",
              type: "bar",
              zlevel: 1,
              itemStyle: {
                normal: {
                  barBorderRadius: 30,
                  color:"#00EBF4",
                },
              },
              label:{
                show:true,
                position:'inside',
                color:'#000',
                fontSize:16,
              },
              barWidth: 16,
              data: [],//yData
            },
            {
              name: "背景",
              type: "bar",
              barWidth: 16,
              barGap: "-100%",
              data: [],//yData,
              itemStyle: {
                normal: {
                  color: "rgba(24,31,68,1)",
                  barBorderRadius: 30,
                },
              },
            },
          ],
        };

        this.myChart12.setOption(option)
        window.addEventListener('resize',this.sizeFunOfMyChart12)
      },
      sizeFunOfMyChart12(){
        if(this.myChart12){
          this.myChart12.resize()
        }
      },

      setConsYearChart(){
        var chart31 = this.$refs.consYearSalesChart;
        this.myChart31 = echarts.getInstanceByDom(chart31);
        if(this.myChart31 === undefined){
          this.myChart31 = echarts.init(chart31);
        }else{
          this.myChart31.dispose()
          this.myChart31 = null;
          this.myChart31 = echarts.init(chart31);
        }

        var option = {
          tooltip: {},
          grid: {
            top: "8%",
            left: "1%",
            right: "1%",
            bottom: "8%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: true,
              axisLine: {
                //坐标轴轴线相关设置。数学上的x轴
                show: true,
                lineStyle: {
                  color: "rgba(0,0,0,0)",
                },
              },
              axisLabel: {
                //坐标轴刻度标签的相关设置
                textStyle: {
                  color: "#d1e6eb",
                  margin: 15,
                  fontSize:8,
                },
              },
              axisTick: {
                show: false,
              },
              data:[],//xArr
            },
          ],
          yAxis: [
            {
              type: "value",
              min: 0,
              splitNumber: 7,
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#0a3256",
                },
              },
              axisLine: {
                show: false,
              },
              axisLabel: {
                margin: 20,
                textStyle: {
                  color: "#d1e6eb",
                  fontSize:8,
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          series: [
            {
              name: "消耗总量",
              type: "line",
              // smooth: true, //是否平滑曲线显示
              			// symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
              showAllSymbol: false,
              symbol: "emptyCircle",
              symbolSize: 0,
              lineStyle: {
                normal: {
                  color: "#00EBF4", // 线条颜色
                },
                borderColor: "#f0f",
              },
              label: {
                show: false,
                position: "top",
                textStyle: {
                  color: "#fff",
                },
              },
              itemStyle: {
                normal: {
                  color: "#00EBF4",
                },
              },
              tooltip: {
                show: false,
              },
              areaStyle: {
                //区域填充样式
                normal: {
                  //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                  color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: "#00EBF4",
                      },
                      {
                        offset: 1,
                        color: "rgba(0,0,0, 0)",
                      },
                    ],
                    false
                  ),
                  shadowColor: "rgba(53,142,215, 0.9)", //阴影颜色
                  shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                },
              },
              data: [],//yArr
            }
          ],
        };

        this.myChart31.setOption(option)
        window.addEventListener('resize',this.sizeFunOfMyChart31)
      },
      sizeFunOfMyChart31(){
        if(this.myChart31){
          this.myChart31.resize()
        }
      },


      // 触点
      getEquipDis(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/stats/province-hospital';
        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){

              this.provinceArray = this.handleNumber(obj.data.provinceAmount)
              this.hospitalArray = this.handleNumber(obj.data.hospitalAmount)

              if(obj.data.provinces){
                this.hospitalDisArray = obj.data.provinces;
                areaConversionUtil.codeToName(this.hospitalDisArray);
                // this.setCityChart()

                this.handleDataOfEquipDis();
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{

          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      handleDataOfEquipDis(){
        var array = this.hospitalDisArray
        var xData = []
        var yData = []
        array.forEach(element=>{
          xData.push(element.provinceName)
          yData.push(element.hospitalAmount)
        })

        this.myChart12.setOption({
          yAxis:[{data: xData},{data: yData}],
          series:[{data:yData},{data:yData}]
        })
      },

      getConsSalesDistribution(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/stats/consumable-use/brief';
        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.total){
                this.consSalesData.total = obj.data.total;
              }
              if(obj.data.year){
                this.consSalesData.year = obj.data.year;
              }
              if(obj.data.month){
                this.consSalesData.month = obj.data.month;
              }
              if(obj.data.today){
                this.consSalesData.today = obj.data.today;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{

          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },

      getConsYearDistribution(){
        var date = new Date()
        var startTime = ''
        var endTime = date.getFullYear() + '-' + this.judgeNumber((date.getMonth()+1))
        var chazhi = date.getMonth()+1 - 11
        if(chazhi <= 0){
          startTime = (date.getFullYear()-1) + '-' + this.judgeNumber((12+chazhi))
        }else{
          startTime = date.getFullYear() + '-01'
        }
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/stats/ship/consumable/month-total';
        const params = {start:startTime,end:endTime}


        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:params
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.value){
                this.consYearData.value = obj.data.value;
              }
              if(obj.data.year){
                this.consYearData.year = obj.data.year
              }
              if(obj.data.month){
                this.consYearData.month = obj.data.month
              }
              // this.setConsYearChart()
              this.handleDataOfConsYear();
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{

          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      handleDataOfConsYear(){
        var xArr = [];
        for(var i=0;i<this.consYearData.year.length;i++){
          xArr.push(this.consYearData.year[i]+'/'+this.consYearData.month[i]);
        }
        var yArr = this.consYearData.value;

        this.myChart31.setOption({
          xAxis: [{data:xArr}],
          series:[{data:yArr}]
        })
      },

      // 6各省设备医院统计
      getDistribution(){
        this.loading = true
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/stats/province';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.provinces){
                // 获取数据
                this.mapDistributionData = obj.data.provinces;
                areaConversionUtil.codeToName(this.mapDistributionData);
                // this.setMap()

                this.handleDataOfMapDistribution()
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },

      handleDataOfMapDistribution(){
        // 数据处理
        var originalData = this.mapDistributionData;

        var outdata = [];

        // 名字处理
        for (var i = 0; i < originalData.length; i++) {
          var element = originalData[i];
          var name = element.provinceName
          if(name == '新疆维吾尔自治区'){name = '新疆'}
          else if(name == '内蒙古自治区'){name = '内蒙古'}
          else if(name == '宁夏回族自治区'){name = '宁夏'}
          else if(name == '广西壮族自治区'){name = '广西'}
          else if(name == '西藏自治区'){name = '西藏'}
          else if(name == '澳门特别行政区'){name = '澳门'}
          else if(name == '香港特别行政区'){name = '香港'}
          else {name = name.substring(0,name.length-1)}
          outdata.push({
            name:name,
            value:element.equipmentAmount
          })
        }
        this.myMapChart.setOption({
          series:[{data: outdata}]
        });
      },
    }
  }
</script>


<style lang="scss" scoped>
.container{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  // background: url('../../assets/image/home/show_back.png');
  -moz-background-size: 100% 100%;
  background-size: 100% 100%;

  // .container>>-webkit-scrollbar{
  //   width: 6px;
  //   height: 8px;
  //   background-color: #000;
  // }

  // .container>>-webkit-scrollbar-thumb{
  //   box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  //   -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  //   background-color: red;
  //   border-radius: 3px;
  // }

  .top-header{
    height: 100px;
    background: url('../../assets/image/home/show_top.png') no-repeat;
    -moz-background-size: 100% 100%;
    background-size: 100% 100%;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
        // space-between;
    align-items: center;

    .nav-left{
      float: left;
      width: 15%;
      margin-left: 10px;

      .logo{
        float: left;
        // font-weight: 400;
        margin-top: -32px;
        background-color:rgba(255,255,255,1);
        border-radius:2px;
        padding:3px;
      }
    }

    .nav-center{
      color: #fff;
      font: 30px bold solid;
      font-weight: 500;
      font-family: Arial, Helvetica, sans-serif;

      width: 26%;
    }


    img{
      margin-top: -23px;
      height: 36px;
      margin: 0 auto;
    }

    .nav-right{
      float: right;
      width: 15%;
      margin-right: 10px;

      .fix{
        margin-top: -15px;
        width: 100%;
        height: 30px;
        border: 0;
        text-align: right;
        color: #00EBF4;
        font: 18px bold solid;
        // font: 1em bold solid;
        color: #fff;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
      }
    }
  }

  .content{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin:15px;

    .content-right{
      // width: 320px;
      width: 30%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;

      .part-title{
          font-size: 16px;
          color: #FEFEFE;
          width: 150px;
          height: 28px;
          border-bottom: 2px solid #00EBF4;
          margin: 10px auto;
          border-radius: 2px;
      }

      .part-left-one{
        height: 50%;

        .part-content{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: calc(100%-300px);

          .part-content-detail{
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;


            p{
              color: #fff;
              font: 18px bold solid;
              margin-right: 20px;
              float: left;
              margin-left: 30px;
            }

            span{
              border: 1px solid;
              // background-color: #3963bc;
              padding: 0px 2px 0px 2px;
              color: #00EBF4;
              font-size: 2em;
              font-weight: 600;
              text-align: center;
              margin-left: 4px;
            }
          }
        }

        .part-content-two{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-evenly;
          height: 100%;

          .part-content-sales{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 50px;
            border: 2px rgba(0, 235, 244, 0.4) solid;
            width: 70%;
            height:60px;
            // height: 20%;
            padding-top: 5px;


            p{
              color: #fff;
              font: 13px bold solid;
            }

            span{
              color: #00EBF4;
              // font-size: 2em;
              font-size: 33px;
              font-weight: 600;
              text-align: center;
            }
          }
        }
      }
      .data-analysis{
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .cons-sales{
          width: 100%;

          .cons-sales-chart{
            width: 100%;
            height: 260px;
          }
        }
      }
    }

    .content-center{
      // width: calc(100% - 640px);
      width: 38%;
      height:100%;
      margin-left: 10px;
      margin-right: 10px;
      margin-bottom: 10px;
      // background-color: greenyellow;

      .content-map{
        width: 100%;
        height: 100%;
        float: left;

        .map-back{
          width: 100%;
          height: 100%;
          // background-color: green;

          .echart-map{
            width: 100%;
            height: 100%;
            border-radius: 8px;
            // width: 840px;
            // height: 800px;
            // height: 600px;
          }
        }

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home/display.vue